import { useRecurringGifts } from "CrossFeatureComponents/UserRecurringGifts/RecurringGiftsContext";

import { formatAmountForDisplay } from "Utilities/Amount/formatAmountForDisplay";

import StatBox from "./StatBox";

export default function ThirtyDayTotal() {
  const {
    state: { thirtyDayTotal },
  } = useRecurringGifts();

  const totalWithoutDollarSign = thirtyDayTotal?.replace("$", "");

  const displayValue = `$${formatAmountForDisplay(totalWithoutDollarSign, {
    roundToWholeDollar: true,
  })}`;

  if (!thirtyDayTotal || totalWithoutDollarSign * 1 === 0) return null;

  return (
    <StatBox
      key="remaining"
      text="Upcoming Cumulative Gifts: 30 Days"
      number={displayValue}
    />
  );
}
